<template>
	<div class="crm-jylist" ref="targetElement">
		<div v-if="isShowList"><div class="crm-jylist-body-scroll">
			<div class="showTitle">
				<p>共{{ list.length }}条</p>
				<p @click="showPopup">筛选<van-icon name="brush-o" /></p>
			</div>
			<van-pull-refresh v-model="scroll.refreshing" @refresh="refreshScroll">
				<van-list v-model="scroll.loading" :finished="scroll.finished" finished-text="没有更多了"   @load="loadScroll">
					<van-cell
						:title="item.checkType | convertDict(jy_type)"
						:label="dayjs(item.reportDate).format('YYYY-MM-DD HH:mm')"
						@click="jumpParamsPages('crm-jyreport-hospital', item,list)"
						is-link
						v-for="(item, index) in list"
						:key="index"
					></van-cell>
				</van-list>
			</van-pull-refresh>
		</div>
		<van-popup class="crm-jy-popup" v-model="show">
			<van-row>
				<van-col class="popup-title">类型筛选</van-col>
			</van-row>
			<van-row class="popup-row">
				<van-col class="popup-col" v-for="item in jyList" :key="item.value"
					><van-tag @click="select(item.value)" color="#5f5aa3" size="large" :plain="item.jyRadio" type="primary">{{ item.title }}</van-tag></van-col
				>
			</van-row>
			<van-row class="popup_ok"> <van-button color="#5f5aa3" size="small" @click="onSearch()">确定</van-button></van-row>
		</van-popup></div>
		<!-- <div><JyReportDetail ref="jyDetailRef" @ok="modalFormOk"></JyReportDetail></div> -->
	</div>
</template>

<script>
import crmMixins from "@/utils/crm-mixins";
import api from "@/request/api";
import TYPES from "@/constant/types";
import SexIcon from "@/components/CRM/SexIcon";
import JyReportDetail from "@/views/CRM/InHospitalList/JyReportDetail.vue";
import dayjs from "dayjs";
import { Notify } from "vant";
export default {
	name: "crm-patient",
	mixins: [crmMixins],
	components: { SexIcon,JyReportDetail },
	props: {
		inWardFrom: Object,upData:Number,
	},
	data() {
		return {
			dayjs,
			show: false,
			applyList: [],
			url: {
				list: "/crm-service/crm/crmCmsJyreportlist/list",
			},
			queryParams: {
				column: "report_date",
				order: "desc",
				certId: this.inWardFrom.idCard,
				patientName: this.inWardFrom.patientName,
			},
			statusList: [],
			applyId: "",
			zjh: "",
			isShowList:true,
			jyList: [
				{
					text: "全部",
					title: "全部",
					value: null,
					jyRadio: true,
				},
			],
			isScrollTop:0,
			test:[],
			num:0,
		};
	},
	mounted() {
		this.$nextTick(() => {

			const listInfo=	sessionStorage.getItem("listInfo")
			const tabScrollTop=	sessionStorage.getItem("tabScrollTop")
			this.isScrollTop=tabScrollTop
		if(!!listInfo&&listInfo.length!=0){
this.list=JSON.parse(listInfo);
const $wrapper = document.querySelector('.crm-jylist');


		$wrapper.scrollTop = tabScrollTop;
		}
		})

	},
	watch: {
    upData(newVal, oldVal) {
      console.log('myData 改变了: ', newVal, '（之前是：', oldVal, '）');
	  if(newVal!=oldVal){
		this.refreshData();
	  }},
	  list(newVal, oldVal) {

	  if(newVal!=oldVal&&this.num<2){
		const tabScrollTop=sessionStorage.getItem("tabScrollTop")
		console.log("tabScrollTop",tabScrollTop);
		const $wrapper = document.querySelector('.crm-jylist');
		$wrapper.scrollTop = tabScrollTop;
		this.num=this.num+1
		console.log("wrapper",$wrapper.scrollTop,this.num);
// 		sessionStorage.removeItem("detailPageNo");
// sessionStorage.removeItem("listInfo");
// sessionStorage.removeItem("tabScrollTop");

	  }
    }},
	methods: {
		jumpParamsPages(path, params,listInfo) {

			const $wrapper = document.querySelector('.crm-jylist');
			console.log(path,params,$wrapper);
			const detailPageNo=Math.ceil(listInfo.length / 10);
			sessionStorage.setItem('detailPageNo',detailPageNo)
			sessionStorage.setItem("listInfo",JSON.stringify(listInfo))
			sessionStorage.setItem("tabScrollTop",$wrapper.scrollTop)
            this.$router.push({name: path,params: {params:params}});
        },
		modalFormOk(a){
			this.isShowList=a;
			// document.querySelector("crm-jylist").scrollTop=this.isScrollTop
		},
		openParamsPage(path, params) {
			console.log('page', document.querySelector("crm-inhospital-detail"));
	console.log('inhospital', document.querySelector("crm-jylist-body-scroll"));
	console.log('test', document.querySelector("test"));
			let pageScrollTop =document.querySelector("crm-inhospital-detail")
			this.isScrollTop = pageScrollTop ? pageScrollTop.scrollTop : 0;
            console.log("aaaaa",pageScrollTop);
			// this.$refs.jyDetailRef.show(params);
			// this.isShowList=false;
            // this.$router.push({name: path,params: {params:params}});
        },
		refreshData(a) {
			this.jy_type.map((item) => {
			this.$set(item, "jyRadio", true);
		});
		this.jyList = this.jyList.concat(this.jy_type);	this.loadPage();
		},
		showPopup() {
			this.show = true;
		},
		showPopup() {
			this.show = true;
		},
		select(value) {
			let that = this;
			console.log("		that.jyList", that.jyList);
			that.jyList.map((i) => {
				if (value == i.value) {
					i.jyRadio = !i.jyRadio;
					that.queryParams.checkType = i.value;
				} else {
					i.jyRadio = true;
				}
			});
		},
		onSearch() {
			this.show = false;
			this.loadPage();
		},
	},

		// beforeRouteEnter (to, from, next) {
		// 	console.log('222222222222222222', to, from)
		// 	sessionStorage.setItem("tabScrollTop",to.meta.scrollTop)
		// 	// this.tabScrollTop=from.meta.scrollTop
		// 	next();
		// },
};
</script>

<style lang="less">
.crm-jylist {
	background-color: #f2f2f2;
    width: 100vw;
    height: 100vh;
    overflow: auto;
	text-align: left;
	padding-bottom: 6rem;
	.showTitle {
		// margin-top: 2px;
		background-color: #fff;
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding: 0.3rem 0.533rem 0.1rem;
		p {
			color: #969799;
			text-align: left;
			font-weight: 400;
			font-size: 0.647rem;
			line-height: 1.04rem;
			margin-bottom: 0rem;
		}
	}
}

.crm-jy-popup {
	.popup_ok {
		text-align: right;
		margin-top: 20px;
	}
	padding: 80px 50px;
	width: 80vw;
	border-radius: 10px;
	.popup-title {
		font-size: 32px;
		font-weight: 600;
		line-height: 22px;
		margin-bottom: 20px;
	}
}
.crm-jylist .showTitle {
	// margin-top: 2px;
	background-color: #fff;
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding: 0.3rem 0.533rem 0.1rem;
	p {
		color: #969799;
		text-align: left;
		font-weight: 400;
		font-size: 0.647rem;
		line-height: 1.04rem;
		margin-bottom: 0rem;
	}
}
.popup-row {
	.popup-col {
		width: 33%;
		padding-top: 40px;

		span {
			width: 100%;
			justify-content: center;
		}
		&:nth-child(3n + 1) {
			padding-right: 10px;
		}
		&:nth-child(3n + 2) {
			padding-left: 5px;
			padding-right: 5px;
		}

		&:nth-child(3n + 3) {
			padding-left: 10px;
		}
	}
}
</style>
